const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: 'rgba(230,230,230,0.8)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/GetStarted/styles.js